import React from "react";
// import Image from "../../../../assets/image/image";
import IntroductionContainer from "./index.css";

const Position = () => {
  return (
    <IntroductionContainer.PositionDiv>
      <h1>조직도</h1>
      {/* 호스팅에 맞춘 사진 주소 ( 사진 로드가 안되서 http를 사용함 ) */}
      <div className="img">
        <img
          src="http://kcima.org/static/media/position1.84b45f3f.png"
          alt="회장"
        />
      </div>
      <div className="img">
        <img
          src="http://kcima.org/static/media/position2.6848c859.png"
          alt="임원"
        />
      </div>
      <div className="img">
        <img
          src="http://kcima.org/static/media/position3.89961c6a.png"
          alt="임원"
        />
      </div>
      <div className="img">
        <img
          src="http://kcima.org/static/media/position4.8ebac627.png"
          alt="임원"
        />
      </div>
    </IntroductionContainer.PositionDiv>
  );
};

export default Position;
